import Track from 'track/Track.js';
import React, { Component } from 'react';
import { connect } from "react-redux";
import PianoRollTimeGridStep from 'components/pianoroll/PianoRollTimeGridStep.js';
import Resolution from 'engine/Resolution.js';
import {getPagination} from 'components/pianoroll/PianoRollPagination.js';
const WIDTH = 36;

const DOUBLE_CLICK = 250;

class PianoRollTimeRow extends Component {
    constructor(props) {
        super(props);
        this.mouseDown = false;

        this.lastClick = undefined;
    }

    get width() {
        return WIDTH * this.props.resolution.resolution / 16;
    }

    onMouseDown(e) {
        let time = new Date().getTime();
        if (time - this.lastDoubleClick < DOUBLE_CLICK) {
            this.props.setMinXScale();
            return;
        }
        this.lastDoubleClick = time;
        
        let _x = e.clientX - 53;
        let x = _x + this.props.wrapperRef.current.scrollLeft;
        this.zoomStep = x / (this.props.xScale * WIDTH);
        this.zoomOffset = _x;
        this.mouseDown = true;
        this.dragStartY = e.pageY;
        this.dragY = e.pageY;

        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setInterval(() => {
            if (this.mouseDown) {
                let yDiff = this.dragY - this.dragStartY;
                this.props.zoomHorizontally(yDiff, this.zoomStep, this.zoomOffset);
            }
        }, 25);
    }

    onMouseUp(e) {
        this.mouseDown = false;
        this.dragStartY = undefined;

        if (this.interval) {
            clearInterval(this.interval);
            this.interval = undefined;
        }
    }

    onMouseMove(e) {
        if (!this.mouseDown) {
            return;
        }

        this.dragY = e.pageY;
    }

    render() {
        if (this.props.track.pattern === undefined) {
            return (
                <div></div>
            );
        }
        let trackSteps = this.props.track.getStepsAtResolution(this.props.resolution);

        let style = {
            width: WIDTH * this.props.xScale * this.props.track.getEasyPattern().pattern.length(this.props.resolution)
        };
        return (
            <div
              style={style}
              onMouseLeave={(e) => this.onMouseUp(e)}
              onMouseMove={(e) => this.onMouseMove(e)}
              onMouseDown={(e) => this.onMouseDown(e)}
              onMouseUp={(e) => this.onMouseUp(e)}
              draggable={false}
              className="piano-roll-time-row">
              {trackSteps.map(
                  (step, i) =>
                      <PianoRollTimeGridStep
                        key={"piano-time-" + i}
                        track={this.props.track}
                        isLooping={this.props.isLooping}
                        height={this.props.height}
                        sequencerEngine={this.props.sequencerEngine}
                        resolution={this.props.resolution}
                        xScale={this.props.xScale}
                        stepsLength={this.props.stepsLength}
                        stepNumber={i}/>)}
            </div>
        );
    }

    isAlternateColor(i, barLength, resolution) {
        return Math.ceil((i + 1) / barLength) % 2 != 0;
    }
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    let steps = state.tracks.trackSteps[
        props.track.subSequence.isTrack ?
            props.track.subSequence.id : props.track.trackNumber];

    return {
        resolution: state.sequencer.displayResolution,
        stepsLength: steps === undefined ? 32 : steps.length,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollTimeRow);
